import './Footer.css';

function Footer() {
  return (
    <div className='footer'>
      <div>
        <div className='footer_title'>상호명 : (주) batman</div>
        <div>회사위치 : 고담시 </div>
      </div>
      <div className='footer_telphone'>TEL.1336</div>
    </div>
  );
}

export default Footer;
